import "./GridCard.css";
import dots from "../../assets/dots.svg";
import gridOne from "../../assets/grid-one.svg";
import gridTwo from "../../assets/grid-two.svg";
import gridThree from "../../assets/grid-one.svg";
const GridCard = () => {
  return (
    <section className="grid-card-section" id="two">
      <div className="container">
        <div className="grid-card-heading">
          <div className="section-tag">
            <img src={dots} alt="dots" />
            <p>Overview</p>
          </div>
          <h2 className="grid-card-h2">
            The Orchestration Engine for AI Governance
          </h2>
          <p>
            AgentGRC.ai enables real-time governance across the AI lifecycle
            with autonomous oversight, regulatory mapping, and built-in policy
            enforcement
          </p>
        </div>
        <div className="grid-card-content">
          <div className="grid-card-wrapper">
            <div className="row card-row-one">
              <div className="col-12 col-sm-6 col-md-6 col-lg-6">
                <div className="grid-card">
                  <h3>Cross-Functional Collaboration</h3>
                  <p>
                    Enable seamless coordination between legal, risk, IT, and
                    data science teams through a unified governance system.
                  </p>
                </div>
              </div>
              <div className="col-12 col-sm-6 col-md-6 col-lg-6 image-div">
                <img src={gridOne} alt="grid-card-image" />
              </div>
            </div>
            <div className="row card-row-two row-reverse">
              <div className="col-12 col-sm-6 col-md-6 col-lg-6">
                <div className="grid-card">
                  <h3>Automated Compliance Mapping</h3>
                  <p>
                    Align with evolving global regulations like the EU AI Act,
                    NIST RMF, and ISO 42001 — without manual effort.
                  </p>
                </div>
              </div>
              <div className="col-12 col-sm-6 col-md-6 col-lg-6 image-div">
                <img src={gridTwo} alt="grid-card-image" />
              </div>
            </div>
            <div className="row card-row-three">
              <div className="col-12 col-sm-6 col-md-6 col-lg-6">
                <div className="grid-card">
                  <h3>Real-Time Risk Response</h3>
                  <p>
                    Detect model drift, bias, and performance issues as they
                    happen — and trigger mitigation instantly.
                  </p>
                </div>
              </div>
              <div className="col-12 col-sm-6 col-md-6 col-lg-6 image-div">
                <img src={gridThree} alt="grid-card-image" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default GridCard;
